<template>
  <div style="height: 100%">
    <!--机房情况-->
    <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;"></label>
    <el-row style="height: 20%">
      <el-col :span="8">
        <el-col :span="18" style="margin-left: 20%;">
          <div class="summary roomSummary pointer" @touchstart="toRouter('/overview')"  @click="toRouter('/overview')">
                <span class="summaryData"><span
                  id="gatewayCount">{{ deviceSummary.spaceCount ? deviceSummary.spaceCount : 0 }} </span><span
                  style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;">
            空间总数
          </div>
        </el-col>
      </el-col>
      <el-col :span="8">
        <el-col :span="18" style="margin-left: 15%">
          <div class="summary alarmSummary pointer" @touchstart="toRouter('/overview')"  @click="toRouter('/overview')">
                <span class="summaryData "><span
                  id="gatewayAlarm" class="numberClass">{{ powerDeviceSummary ? powerDeviceSummary : 0 }} </span><span
                  style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;">
            动力设备总数
          </div>
        </el-col>
      </el-col>
      <el-col :span="8">
        <el-col :span="18" style="margin-left: 10%">
          <div class="summary deviceSummary pointer" @touchstart="toRouter('/overview')"  @click="toRouter('/overview')">
              <span class="summaryData"><span
                id="deviceCount">{{ environmentDeviceSummary ? environmentDeviceSummary : 0 }} </span><span
                style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;text-align: left;">
            环境设备总数
          </div>
        </el-col>
      </el-col>
    </el-row>
    <!--当前状态总览-->
    <el-row style="height: 55%;margin-top: 4%;display: flex;justify-content: center">
      <el-col :span="12" class="barColClass">
        <power-bar-chart :data="powerData" ref="powerbarChart" style="height: 90%"></power-bar-chart>
        <div style="display: flex;align-items: center;justify-content:center;margin-top: 20px">
          <span class="colSpan"></span>
          <span style="margin: 0 10px 0 10px;font-size: 14px;color: #07E6F8;">动力设备告警</span>
          <span class="colSpan"></span>
        </div>
      </el-col>
      <el-col :span="12" class="barColClass">
        <power-bar-chart :data="environmentData" ref="environmentbarChart" style="height: 90%"></power-bar-chart>
        <div style="display: flex;align-items: center;justify-content:center;margin-top: 20px">
          <span class="colSpan"></span>
          <span style="margin: 0 10px 0 10px;font-size: 14px;color: #07E6F8;">环境设备告警</span>
          <span class="colSpan"></span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PowerBarChart from '@/components/echarts/PowerBarChart'
import {countDeviceStatusByTag, getDeviceSummary} from '@/network/device-info';
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "PowerStatistics",
  mixins: [platenLayoutEdit],
  components: {
    PowerBarChart
  },
  data() {
    return {
      data: null,
      // 机房总数
      deviceSummary: 0,
      // 动力设备总数
      powerDeviceSummary: 0,
      // 环境设备总数
      environmentDeviceSummary: 0,
      // 动力设备信息
      powerData: [],
      // 环境设备信息
      environmentData: []
    }
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'PowerStatistics:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'PowerStatistics')
  },
  methods: {
    getData() {
      countDeviceStatusByTag().then(res => {
        if (res.code === 0) {
          this.data = res.data;
          if (res.data !== null) {
            let item = res.data
            let powerIndex = 0
            let environmentIndex = 0
            res.data.tag.forEach((item1, index) => {
              if (item1 === '动力设备') {
                powerIndex = index
              } else if (item1 === '环境设备') {
                environmentIndex = index
              }
            })
            this.powerDeviceSummary = item.online[powerIndex] + item.offline[powerIndex]
            this.environmentDeviceSummary = item.online[environmentIndex] + item.offline[environmentIndex]
            // 动力，环境设备信息
            // this.powerData = [item.normal[powerIndex], item.online[powerIndex], item.offline[powerIndex], item.exception[powerIndex]]
            this.powerData = [item.online[powerIndex], item.offline[powerIndex], item.normal[powerIndex], item.exception[powerIndex]]
            // this.environmentData = [item.normal[environmentIndex], item.online[environmentIndex], item.offline[environmentIndex], item.exception[environmentIndex]]
            this.environmentData = [item.online[environmentIndex], item.offline[environmentIndex], item.normal[environmentIndex], item.exception[environmentIndex]]
          }
          this.data.statusName = ["正常", "告警", "在线", "离线"];
        }
      })
      getDeviceSummary().then(res => {
        if (res.code === 0) {
          this.deviceSummary = res.data
        }
      })
    },
    toRouter(router) {
      if (this.isPlatenLayoutEditing) return
      // let routeUrl = this.$router.resolve({
      //   path: router
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push(router)
    }
  }
}
</script>

<style scoped>
.summary {
  background-position: 0 50%;
  background-size: contain;
  background-repeat: no-repeat;
  text-align: right;
}

.summaryData {
  line-height: 8vh;
  padding-right: 35%;
  font-size: 30px;
  color: rgba(0, 227, 246, 1);
}

.roomSummary {
  background-image: url('../../assets/images/index/roomSummary.gif');
  margin-top: 5%;
}

.deviceSummary {
  background-image: url('../../assets/images/index/deviceSummary.gif');
  margin-top: 5%;
}

.alarmSummary {
  background-image: url('../../assets/images/index/platen-alarm.gif');
  margin-top: 5%;
  color: rgba(255, 67, 76, 1);
}

.colSpan {
  width: 26px;
  height: 0;
  border: 1px solid #1A5384;
  display: inline-block;
}

.barColClass {
  height: 100%;
  width: 40%;
}
</style>
